var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinitoreYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-954 3939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.407,428.565l-1.317-1.958H53.606a8.331,8.331,0,0,0-.46-.757V419H50v4.164a7.843,7.843,0,0,0-5.168-.573l.052.024.444,1.907.016.036A6.309,6.309,0,0,0,46.6,437a5.972,5.972,0,0,0,3.834-1.4l.053.114,1.486,1.209L52,436.9a8.239,8.239,0,0,0,1.429-1.786H58.09l1.317-1.958H63.5v-4.594Z",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.708,430.711A6.107,6.107,0,1,0,46.6,437a6.2,6.2,0,0,0,6.1-6.289",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,436.9A8.5,8.5,0,0,0,53.783,426.9a8,8,0,0,0-8.948-4.3",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y1: 3.842,
    transform: "translate(964.003 -3936)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,419h3.143v6.641",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.778,426.607h4.313l1.316,1.958H63.5v4.594",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.778,435.117h4.313l1.316-1.958H63.5",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.486,
    y2: 1.209,
    transform: "translate(964.49 -3919.284)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.443,
    y1: 1.906,
    transform: "translate(958.886 -3932.385)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(954 -3939)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinitoreYellow);
export default __webpack_public_path__ + "static/media/finitore_yellow.a0384d534be87bab3d75370769fdd30a.svg";
export { ForwardRef as ReactComponent };